<template>
  <div class="providers">
    <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
    <router-view></router-view>
  </div>
</template>
<script>
import { BBreadcrumb } from 'bootstrap-vue'

export default {
  components: {
    BBreadcrumb
  },
  data () {
    return {
      breadcrumb: [
        {
          text: 'Tablero',
          to: { name: 'dashboard' }
        },
        {
          text: 'Almacénes',
          to: { name: 'warehouse' }
        },
        {
          text: 'Lista',
          active: true
        }
      ]
    }
  }
}
</script>
